export default __webpack_public_path__ + "static/media/settings.f7927ce8.svg";